module.exports = __webpack_public_path__ + "img/value-blocks-slider-nissan.ec05a9cb.png";